document.addEventListener('DOMContentLoaded', function () {
  var cartToggle = document.querySelectorAll('[data-cart-toggle]');
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var navToggle = document.querySelector('[data-nav-toggle]');
  var siteNav = document.querySelector('[data-site-nav]');

  function toggleDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    if (overlay) overlay.classList.toggle('is-open', open);
  }

  cartToggle.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      toggleDrawer(!drawer.classList.contains('is-open'));
    });
  });

  if (overlay) overlay.addEventListener('click', function () { toggleDrawer(false); });

  if (navToggle && siteNav) {
    navToggle.addEventListener('click', function () {
      var isOpen = siteNav.style.display === 'flex';
      siteNav.style.display = isOpen ? 'none' : 'flex';
    });
  }

  // Add to cart via fetch, then refresh drawer count
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function () { window.location.href = '/cart'; })
        .catch(function (err) { console.error('Add to cart failed', err); });
    });
  });

  // Product variant picker: sync price, image, and cart id when option selects change
  var productRoot = document.querySelector('[data-product-root]');
  if (productRoot) {
    var variantScript = productRoot.querySelector('[data-product-variants]');
    var selects = Array.prototype.slice.call(productRoot.querySelectorAll('[data-option-selector]'));
    var priceEl = document.getElementById('ProductPrice');
    var imageEl = document.getElementById('ProductMainImage');
    var idInput = document.getElementById('ProductVariantId');
    var addBtn = document.getElementById('ProductAddToCart');
    var noteEl = document.getElementById('ProductPreorderNote');
    var variants = [];

    if (variantScript) {
      try { variants = JSON.parse(variantScript.textContent); } catch (err) { console.error('Could not parse variant data', err); }
    }

    function findMatchingVariant() {
      var selected = selects
        .sort(function (a, b) { return Number(a.getAttribute('data-option-index')) - Number(b.getAttribute('data-option-index')); })
        .map(function (s) { return s.value; });
      return variants.find(function (v) {
        return v.optionValues.length === selected.length && v.optionValues.every(function (val, i) { return val === selected[i]; });
      });
    }

    function applyVariant(variant) {
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        var html = '';
        if (variant.compareAtPrice) {
          html += '<s style="opacity:.5; margin-right:8px;">' + variant.compareAtPrice + '</s>';
        }
        html += variant.price;
        priceEl.innerHTML = html;
      }
      if (imageEl && variant.imageUrl) {
        imageEl.removeAttribute('srcset');
        imageEl.removeAttribute('sizes');
        imageEl.src = variant.imageUrl;
      }
      var isPreorder = variant.available && variant.inventoryManagement && variant.inventoryQuantity <= 0;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (isPreorder) {
          addBtn.textContent = addBtn.getAttribute('data-label-preorder') || 'Pre-order';
        } else {
          addBtn.textContent = variant.available
            ? (addBtn.getAttribute('data-label-available') || 'Add to cart')
            : (addBtn.getAttribute('data-label-sold-out') || 'Sold out');
        }
      }
      if (noteEl) noteEl.style.display = isPreorder ? '' : 'none';
    }

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        applyVariant(findMatchingVariant());
      });
    });
  }
});